/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3TimeseriesRewardNodeProvidersFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3TimeseriesRewardNodeProvidersFormat = ClosedEnum<
  typeof GetApiV3TimeseriesRewardNodeProvidersFormat
>;

export type GetApiV3TimeseriesRewardNodeProvidersRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3TimeseriesRewardNodeProvidersFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3TimeseriesRewardNodeProvidersFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3TimeseriesRewardNodeProvidersFormat> = z
    .nativeEnum(GetApiV3TimeseriesRewardNodeProvidersFormat);

/** @internal */
export const GetApiV3TimeseriesRewardNodeProvidersFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3TimeseriesRewardNodeProvidersFormat> =
    GetApiV3TimeseriesRewardNodeProvidersFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3TimeseriesRewardNodeProvidersFormat$ {
  /** @deprecated use `GetApiV3TimeseriesRewardNodeProvidersFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3TimeseriesRewardNodeProvidersFormat$inboundSchema;
  /** @deprecated use `GetApiV3TimeseriesRewardNodeProvidersFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3TimeseriesRewardNodeProvidersFormat$outboundSchema;
}

/** @internal */
export const GetApiV3TimeseriesRewardNodeProvidersRequest$inboundSchema:
  z.ZodType<
    GetApiV3TimeseriesRewardNodeProvidersRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3TimeseriesRewardNodeProvidersFormat$inboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(86400),
  });

/** @internal */
export type GetApiV3TimeseriesRewardNodeProvidersRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3TimeseriesRewardNodeProvidersRequest$outboundSchema:
  z.ZodType<
    GetApiV3TimeseriesRewardNodeProvidersRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3TimeseriesRewardNodeProvidersRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3TimeseriesRewardNodeProvidersFormat$outboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(86400),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3TimeseriesRewardNodeProvidersRequest$ {
  /** @deprecated use `GetApiV3TimeseriesRewardNodeProvidersRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3TimeseriesRewardNodeProvidersRequest$inboundSchema;
  /** @deprecated use `GetApiV3TimeseriesRewardNodeProvidersRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3TimeseriesRewardNodeProvidersRequest$outboundSchema;
  /** @deprecated use `GetApiV3TimeseriesRewardNodeProvidersRequest$Outbound` instead. */
  export type Outbound = GetApiV3TimeseriesRewardNodeProvidersRequest$Outbound;
}

export function getApiV3TimeseriesRewardNodeProvidersRequestToJSON(
  getApiV3TimeseriesRewardNodeProvidersRequest:
    GetApiV3TimeseriesRewardNodeProvidersRequest,
): string {
  return JSON.stringify(
    GetApiV3TimeseriesRewardNodeProvidersRequest$outboundSchema.parse(
      getApiV3TimeseriesRewardNodeProvidersRequest,
    ),
  );
}

export function getApiV3TimeseriesRewardNodeProvidersRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3TimeseriesRewardNodeProvidersRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3TimeseriesRewardNodeProvidersRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3TimeseriesRewardNodeProvidersRequest' from JSON`,
  );
}
